import { useEffect, useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { DetailWrapper, DetailLoader, O } from "../../../../../features/ui"
import { Delivery, DeliveryMethod, DeliveryOrder } from "../../../state/types"
import { DeliveryOrderDetail } from "./deliveryOrderDetail"
import { Operation, useOperationLoaders } from "../../../../operations"
import { Customer, useCustomerLoaders } from "../../../../sales"
import { useDeliveryLoaders } from "../../../loaders/deliveryLoaders"

export const DeliveryOrderDetailLoader = () => {
    const { dataType } = useRoutesHooks().parseUrl()
    const deliveryOrder = dataType! as DeliveryOrder

    const [operation, setOperation] = useState<Operation>()
    const [deliveries, setDeliveries] = useState<Delivery[]>([])
    const [customer, setCustomer] = useState<O<Customer>>()
    const [ready, setReady] = useState(false)

    const operationLoaders = useOperationLoaders()
    const customerLoaders = useCustomerLoaders()
    const deliveryLoaders = useDeliveryLoaders()

    const parentPath = useMemo(() =>
        deliveryOrder.method === DeliveryMethod.PICKUP ? RoutePath.PICKUP_ORDERS : RoutePath.SHIPMENT_ORDERS,
    [])

    const load = async () => {
        const { loadOperation } = operationLoaders()
        const loadedOperation = await loadOperation(deliveryOrder.table, deliveryOrder.operationId)
        setOperation(loadedOperation)
        const { loadOrderDeliveries } = deliveryLoaders()
        const loadedDeliveries = await loadOrderDeliveries(deliveryOrder.id)
        setDeliveries(loadedDeliveries)
        if (deliveryOrder.method !== DeliveryMethod.RECEPTION) {
            const { loadCustomer } = customerLoaders()
            const loadedCustomer = await loadCustomer(deliveryOrder.customerId!)
            setCustomer(loadedCustomer)
        }
    }

    useEffect(() => {
        load().then(() => setReady(true))
    }, [])

    return (
        <DetailWrapper parentPath={parentPath}>
            <DetailLoader ready={ready}>
                <DeliveryOrderDetail
                    deliveryOrder={deliveryOrder}
                    operation={operation!}
                    deliveries={deliveries}
                    customer={customer}
                />
            </DetailLoader>
        </DetailWrapper>
    )
}
